var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-w"},[_c('div',{staticStyle:{"padding-left":"12px"}},[_c('el-link',{staticClass:"back",attrs:{"underline":false},on:{"click":function () {this$1.$router.go(-1)}}},[_c('img',{attrs:{"alt":"<","src":require("../../assets/image/ic_back.svg")}}),_vm._v(" 返回 ")])],1),_c('Info',{attrs:{"area":_vm.area}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }